import { ChangeDetectionStrategy, Component, input, Signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ProjectOrderModel } from '@project/components/project/project-order/project-order-model';
import { SvgIconComponent } from '@shared/svg-icon/svg-icon.component';

@Component({
  selector: 'app-project-order-thanks',
  templateUrl: './project-order-thanks.component.html',
  styleUrls: ['./project-order-thanks.component.scss'],
  standalone: true,
  imports: [
    SvgIconComponent,
    TranslateModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectOrderThanksComponent {
  public model = input.required<ProjectOrderModel | {requestSucceeded: Signal<boolean | undefined>}>();
  public orderedDirectly = input.required<boolean>();
}
